export default function EditHealthResourcesDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  ssDialogService,
  loaderService,
  bcpDataService
) {
  const vm = this;

  vm.handleClose = _handleClose;
  vm.handleSave = _handleSave;
  vm.validateURL = _validateURL;

  /** **************************************************
   * Event Handlers
   */

  function _handleClose() {
    _closeDialog();
  }

  function _handleSave() {
    if ($scope.bcpEditHealthResourceForm.$invalid) {
      return false;
    }
    loaderService.showViewLoader = true;
    return bcpDataService.saveHealthResource(vm.healthResource)
      .then((response) => {
        loaderService.showViewLoader = false;
        if (response.data.result) {
          alerts.error('Error occurred while saving Health Resource.');
        } else {
          alerts.success('The Health Resource has been saved successfully.');
          $rootScope.$broadcast('refreshBCPHealthResource');
          $rootScope.$broadcast('setDocumentRegenerateFlag');
          _closeDialog();
        }
      })
      .catch(() => {
        loaderService.showViewLoader = false;
        alerts.error('Error occurred while saving Health Resource.');
      });
  }

  function _validateURL() {
    // eslint-disable-next-line max-len
    if (vm.healthResource.resourceInformation.startsWith('http://') || vm.healthResource.resourceInformation.startsWith('https://')) {
      vm.scope.bcpEditHealthResourceForm.resourceInformation.$invalid = false;
      vm.scope.bcpEditHealthResourceForm.resourceInformation.$error = '';
      vm.isValid = true;
    } else {
      vm.scope.bcpEditHealthResourceForm.resourceInformation.$invalid = true;
      vm.scope.bcpEditHealthResourceForm.resourceInformation.$error = { pattern: true };
    }
  }

  /** **************************************************
   * Private Functions
   */

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.bcp.editHealthResourcesDialog);
  }
}

EditHealthResourcesDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
  'ssDialogService',
  'loaderService',
  'bcpDataService'
];
